import { render, staticRenderFns } from "./PPIchart.vue?vue&type=template&id=e7729872&"
import script from "./PPIchart.vue?vue&type=script&lang=js&"
export * from "./PPIchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports